// extracted by mini-css-extract-plugin
export default {"container":"src-components-molecule-entryList-entryList-module__container--W9Dfh","table":"src-components-molecule-entryList-entryList-module__table--AnS6l"};